import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, withCtx as _withCtx, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "inhdialog-header" }
const _hoisted_2 = { class: "dialog_name" }
const _hoisted_3 = { class: "dialog_content" }
const _hoisted_4 = {
  key: 0,
  class: "loading-container q-mt-sm"
}
const _hoisted_5 = { class: "field-group__row no-wrap justify-left" }
const _hoisted_6 = {
  key: 1,
  class: "inner_container"
}
const _hoisted_7 = { class: "field-group" }
const _hoisted_8 = { class: "field-group__row no-wrap justify-left" }
const _hoisted_9 = {
  key: 0,
  class: "bold-name mr-xs"
}
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "bold-name mr-xs" }
const _hoisted_12 = {
  key: 0,
  class: "required-asterisk"
}
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { key: 2 }
const _hoisted_15 = { class: "field-group" }
const _hoisted_16 = { class: "field-group__row no-wrap justify-left items-baseline" }
const _hoisted_17 = { class: "bold-name" }
const _hoisted_18 = {
  key: 0,
  class: "required-asterisk"
}
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { class: "field-group" }
const _hoisted_22 = { class: "field-group__row no-wrap justify-left items-center" }
const _hoisted_23 = { class: "bold-name" }
const _hoisted_24 = {
  key: 0,
  class: "field-group"
}
const _hoisted_25 = { class: "field-group__row no-wrap justify-left items-baseline" }
const _hoisted_26 = { class: "bold-name" }
const _hoisted_27 = { class: "field-group" }
const _hoisted_28 = { class: "field-group__row no-wrap justify-left items-baseline" }
const _hoisted_29 = { class: "bold-name" }
const _hoisted_30 = {
  key: 0,
  class: "required-asterisk"
}
const _hoisted_31 = { key: 1 }
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { class: "field-group" }
const _hoisted_34 = { class: "field-group__row no-wrap justify-left items-baseline" }
const _hoisted_35 = { class: "bold-name" }
const _hoisted_36 = {
  key: 0,
  class: "required-asterisk"
}
const _hoisted_37 = { key: 1 }
const _hoisted_38 = { key: 0 }
const _hoisted_39 = { class: "q-mx-xs" }
const _hoisted_40 = {
  key: 2,
  class: "mr-xs"
}
const _hoisted_41 = {
  key: 3,
  class: "file-button q-ml-sm"
}
const _hoisted_42 = {
  key: 0,
  class: "q-mx-xs col",
  style: {"display":"vertical-align: middle","overflow":"hidden","height":"16px","width":"200px","border-right":"1px solid black","border-bottom":"1px solid black"}
}
const _hoisted_43 = {
  style: {"height":"9px","margin-top":"-13px","vertical-align":"middle","display":"inline-flex","flex-direction":"row"},
  class: "nowrap"
}
const _hoisted_44 = {
  key: 1,
  class: "field-group"
}
const _hoisted_45 = { class: "field-group__row no-wrap justify-left items-baseline" }
const _hoisted_46 = { class: "bold-name" }
const _hoisted_47 = {
  key: 0,
  class: "required-asterisk"
}
const _hoisted_48 = { key: 1 }
const _hoisted_49 = {
  key: 2,
  class: "field-group"
}
const _hoisted_50 = { class: "field-group__row no-wrap justify-left items-baseline" }
const _hoisted_51 = { class: "bold-name" }
const _hoisted_52 = {
  key: 3,
  class: "field-group"
}
const _hoisted_53 = { class: "bold-name" }
const _hoisted_54 = { class: "file-list" }
const _hoisted_55 = { key: 0 }
const _hoisted_56 = { class: "field-group" }
const _hoisted_57 = { class: "field-group__row no-wrap justify-left items-center" }
const _hoisted_58 = { class: "bold-name" }
const _hoisted_59 = {
  key: 0,
  class: "q-ml-xs inline-flex"
}
const _hoisted_60 = { class: "field-group" }
const _hoisted_61 = { class: "bold-name flex items-center" }
const _hoisted_62 = { class: "file-list" }
const _hoisted_63 = {
  class: "text-caption",
  style: {"text-align":"right","color":"red"}
}
const _hoisted_64 = {
  key: 1,
  class: "text-caption",
  style: {"text-align":"right","color":"green"}
}
const _hoisted_65 = { class: "field-group" }
const _hoisted_66 = { class: "field-group__row no-wrap justify-left" }
const _hoisted_67 = { class: "bold-name" }
const _hoisted_68 = {
  key: 0,
  class: "field-group q-mb-md"
}
const _hoisted_69 = { class: "row no-wrap justify-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_icon = _resolveComponent("app-icon")!
  const _component_VueDatePicker = _resolveComponent("VueDatePicker")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_counterparty_info_component = _resolveComponent("counterparty-info-component")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _component_native_input = _resolveComponent("native-input")!
  const _component_payment_progress = _resolveComponent("payment-progress")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_connections_table_html = _resolveComponent("connections-table-html")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card = _resolveComponent("q-card")!

  return (_openBlock(), _createBlock(_component_q_card, { class: "inhdialog-container" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t('full_info_on')) + " " + _toDisplayString(_ctx.isPayment ? _ctx.$t('on_payment') : _ctx.$t('on_invoice')) + " \"" + _toDisplayString(_ctx.isPayment ? _ctx.payInfoContainer.Number : _ctx.billInfoContainer.Number) + "\" ", 1),
        _createVNode(_component_app_icon, {
          name: "close",
          width: "18px",
          color: "#979797",
          "hover-color": "#499259",
          cursor: "pointer",
          title: _ctx.$t('close_label'),
          onClick: _ctx.close
        }, null, 8, ["title", "onClick"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.dataLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(8, (n) => {
                return _createElementVNode("div", {
                  key: n,
                  class: "field-group"
                }, [
                  _createElementVNode("div", _hoisted_5, [
                    _cache[11] || (_cache[11] = _createElementVNode("div", { class: "skeleton skeleton-title" }, null, -1)),
                    _createElementVNode("div", {
                      class: _normalizeClass(["skeleton skeleton-text", {
                'skeleton-text-short': n % 3 === 0,
                'skeleton-text-medium': n % 3 === 1,
              }])
                    }, null, 2)
                  ])
                ])
              }), 64))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  (!_ctx.isPayment)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.$t('status_label')) + ":", 1))
                    : _createCommentVNode("", true),
                  (!_ctx.isPayment)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.getBillStatus), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_11, [
                    _createTextVNode(_toDisplayString(_ctx.$t('creation')), 1),
                    (_ctx.isPayment && _ctx.isPaymentEditMode && _ctx.payInfoContainer.CreatedInCrm && !_ctx.editPaymentForm.date)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_12, "*"))
                      : (_openBlock(), _createElementBlock("span", _hoisted_13, ":"))
                  ]),
                  (!_ctx.isPayment || !_ctx.isPaymentEditMode || (_ctx.isPayment && _ctx.isPaymentEditMode && !_ctx.payInfoContainer.CreatedInCrm))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.dateFormatted(_ctx.isPayment ? _ctx.payInfoContainer.Date : _ctx.billInfoContainer.Date)), 1))
                    : (_ctx.isPayment && _ctx.isPaymentEditMode && _ctx.payInfoContainer.CreatedInCrm)
                      ? (_openBlock(), _createBlock(_component_VueDatePicker, {
                          key: 3,
                          utc: "preserve",
                          timezone: "Europe/Moscow",
                          locale: _ctx.$i18n.locale,
                          style: 'width: 150px; min-width: 150px; max-width: 150px;',
                          teleport: true,
                          modelValue: _ctx.editPaymentForm.date,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.editPaymentForm.date) = $event)),
                          "enable-time-picker": false,
                          clearable: false,
                          required: true,
                          format: _ctx.formatDatePicker,
                          "text-input": _ctx.datePickerTextInputOptions
                        }, null, 8, ["locale", "modelValue", "format", "text-input"]))
                      : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createTextVNode(_toDisplayString(_ctx.$t('invoice_type')), 1),
                    (_ctx.isPayment && _ctx.isPaymentEditMode && _ctx.payInfoContainer.CreatedInCrm && (_ctx.editPaymentForm.type == null || _ctx.editPaymentForm.type === undefined))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_18, "*"))
                      : (_openBlock(), _createElementBlock("span", _hoisted_19, ":"))
                  ]),
                  (!_ctx.isPayment || !_ctx.isPaymentEditMode || (_ctx.isPayment && _ctx.isPaymentEditMode && !_ctx.payInfoContainer.CreatedInCrm))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_ctx.financeType(_ctx.isPayment ? _ctx.payInfoContainer.Type : _ctx.billInfoContainer.Type)), 1))
                    : (_ctx.isPayment && _ctx.isPaymentEditMode && _ctx.payInfoContainer.CreatedInCrm)
                      ? (_openBlock(), _createBlock(_component_q_select, {
                          key: 1,
                          flat: "",
                          modelValue: _ctx.editPaymentForm.type,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.editPaymentForm.type) = $event)),
                          style: {"min-width":"150px","padding":"0 !important"},
                          class: "thin-input",
                          "dropdown-icon": "expand_more",
                          "fill-input": "",
                          "bottom-slots": false,
                          dense: "",
                          outlined: "",
                          "emit-value": "",
                          "map-options": "",
                          "option-label": "Name",
                          "option-value": "Id",
                          options: _ctx.paymentTypeOptions
                        }, null, 8, ["modelValue", "options"]))
                      : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.$t('counterparty')) + ":", 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.isPayment ? _ctx.payInfoContainer.Counterparty?.Name : _ctx.billInfoContainer.Counterparty?.Name), 1),
                  (_ctx.isPayment ? _ctx.payInfoContainer.Counterparty?.Id > 0 : _ctx.billInfoContainer.Counterparty?.Id > 0)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createVNode(_component_app_icon, {
                          class: "q-mx-xs",
                          name: "info-circle-outline",
                          width: "18px",
                          color: "#979797",
                          "hover-color": "#499259",
                          cursor: "pointer",
                          title: _ctx.$t('information'),
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showCPartyInfoMode = true))
                        }, null, 8, ["title"]),
                        _createVNode(_component_q_dialog, {
                          modelValue: _ctx.showCPartyInfoMode,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.showCPartyInfoMode) = $event)),
                          "no-shake": "",
                          "full-width": !_ctx.isMobile,
                          maximized: _ctx.isMobile
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_counterparty_info_component, {
                              "counterparty-id": _ctx.isPayment ? _ctx.payInfoContainer.Counterparty?.Id : _ctx.billInfoContainer.Counterparty?.Id,
                              "read-only": _ctx.readOnly,
                              onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showCPartyInfoMode = false))
                            }, null, 8, ["counterparty-id", "read-only"])
                          ]),
                          _: 1
                        }, 8, ["modelValue", "full-width", "maximized"])
                      ], 64))
                    : _createCommentVNode("", true)
                ])
              ]),
              (_ctx.isPayment && _ctx.payInfoContainer.Creator)
                ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.$t('creator')) + ":", 1),
                      _createElementVNode("span", null, _toDisplayString(_ctx.payInfoContainer.Creator.Name), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _createTextVNode(_toDisplayString(_ctx.$t('number')), 1),
                    (_ctx.isPayment && _ctx.isPaymentEditMode && _ctx.payInfoContainer.CreatedInCrm && !String(_ctx.editPaymentForm.number ?? '').trim())
                      ? (_openBlock(), _createElementBlock("span", _hoisted_30, "*"))
                      : (_openBlock(), _createElementBlock("span", _hoisted_31, ":"))
                  ]),
                  (!_ctx.isPayment || !_ctx.isPaymentEditMode || (_ctx.isPayment && _ctx.isPaymentEditMode && !_ctx.payInfoContainer.CreatedInCrm))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(_ctx.isPayment ? _ctx.payInfoContainer.Number : _ctx.billInfoContainer.Number), 1))
                    : (_ctx.isPayment && _ctx.isPaymentEditMode && _ctx.payInfoContainer.CreatedInCrm)
                      ? (_openBlock(), _createBlock(_component_native_input, {
                          key: 1,
                          style: {"min-width":"150px"},
                          modelValue: _ctx.editPaymentForm.number,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.editPaymentForm.number) = $event)),
                          "show-border": true,
                          "disabled-field": false,
                          "edit-on-click": true
                        }, null, 8, ["modelValue"]))
                      : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("div", _hoisted_35, [
                    _createTextVNode(_toDisplayString(_ctx.$t('amount')), 1),
                    (_ctx.isPayment && _ctx.isPaymentEditMode && _ctx.payInfoContainer.CreatedInCrm && (Number(_ctx.editPaymentForm.amount) < 0 || isNaN(Number(_ctx.editPaymentForm.amount))))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_36, "*"))
                      : (_openBlock(), _createElementBlock("span", _hoisted_37, ":"))
                  ]),
                  (!_ctx.isPayment || !_ctx.isPaymentEditMode || (_ctx.isPayment && _ctx.isPaymentEditMode && !_ctx.payInfoContainer.CreatedInCrm))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_38, _toDisplayString(_ctx.isPayment ? _ctx.money(_ctx.payInfoContainer.CalculatedAmount) : _ctx.money(_ctx.billInfoContainer.Amount)) + " " + _toDisplayString(_ctx.isPayment ? _ctx.payInfoContainer.Currency : _ctx.billInfoContainer.Currency), 1))
                    : (_ctx.isPayment && _ctx.isPaymentEditMode && _ctx.payInfoContainer.CreatedInCrm)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createVNode(_component_native_input, {
                            style: {"min-width":"120px"},
                            modelValue: _ctx.editPaymentForm.amount,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.editPaymentForm.amount) = $event)),
                            "input-type": "number",
                            "show-border": true,
                            "disabled-field": false,
                            "edit-on-click": true,
                            "min-number-value": 0
                          }, null, 8, ["modelValue"]),
                          _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.editPaymentForm.currency), 1)
                        ], 64))
                      : _createCommentVNode("", true),
                  (!_ctx.isPayment)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_40, _toDisplayString(_ctx.getPayStatusText), 1))
                    : _createCommentVNode("", true),
                  (!_ctx.isPayment)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                        (
                  _ctx.billInfoContainer.Connections &&
                  _ctx.billInfoContainer.Connections.length
                )
                          ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                              _createVNode(_component_payment_progress, {
                                narrow: true,
                                width: 200,
                                percent: Math.round(_ctx.billInfoContainer.PayedPercent)
                              }, null, 8, ["percent"]),
                              _createElementVNode("div", _hoisted_43, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.billInfoContainer.Connections, (conn, pr_ind) => {
                                  return (_openBlock(), _createBlock(_component_payment_progress, {
                                    key: 'c_' + pr_ind,
                                    percent: Math.round(conn.PayedPercent),
                                    "allow-null-width": true,
                                    width: 
                      (200 * Math.round(conn.AmountPercent)) / 100 -
                      (_ctx.billInfoContainer.Connections.length > 1
                        ? pr_ind === 0 ||
                          pr_ind === _ctx.billInfoContainer.Connections.length - 1
                          ? 0
                          : 1
                        : 0) +
                      2
                    ,
                                    style: _normalizeStyle(`margin-left: ${pr_ind === 0 ? 0 : '-2px'};`),
                                    narrow: true
                                  }, null, 8, ["percent", "width", "style"]))
                                }), 128))
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              (_ctx.isPayment && _ctx.isPaymentEditMode)
                ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                    _createElementVNode("div", _hoisted_45, [
                      _createElementVNode("div", _hoisted_46, [
                        _createTextVNode(_toDisplayString(_ctx.$t('currency')), 1),
                        (!String(_ctx.editPaymentForm.currency ?? '').trim())
                          ? (_openBlock(), _createElementBlock("span", _hoisted_47, "*"))
                          : (_openBlock(), _createElementBlock("span", _hoisted_48, ":"))
                      ]),
                      _createVNode(_component_native_input, {
                        style: {"min-width":"150px"},
                        modelValue: _ctx.editPaymentForm.currency,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.editPaymentForm.currency) = $event)),
                        "show-border": true,
                        "disabled-field": false,
                        "edit-on-click": true
                      }, null, 8, ["modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isPayment && _ctx.isPaymentEditMode)
                ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                    _createElementVNode("div", _hoisted_50, [
                      _createElementVNode("div", _hoisted_51, _toDisplayString(_ctx.$t('currency_rate')) + ":", 1),
                      _createVNode(_component_native_input, {
                        style: {"min-width":"150px"},
                        modelValue: _ctx.editPaymentForm.currencyRate,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.editPaymentForm.currencyRate) = $event)),
                        "input-type": "number",
                        "show-border": true,
                        "disabled-field": false,
                        "edit-on-click": true,
                        "min-number-value": 0
                      }, null, 8, ["modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.billInfoContainer.HasPayments && !_ctx.isPayment)
                ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                    _createElementVNode("div", _hoisted_53, _toDisplayString(_ctx.$t('payments')) + ":", 1),
                    _createElementVNode("div", _hoisted_54, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.billInfoContainer.Payments, (p, pi) => {
                        return (_openBlock(), _createElementBlock("span", {
                          key: 'paym_' + pi
                        }, [
                          _createTextVNode(_toDisplayString(pi + 1) + ") " + _toDisplayString(_ctx.financeType(p.Type)) + ", " + _toDisplayString(p.Counterparty.Name) + ", " + _toDisplayString(_ctx.dateFormatted(p.Date)) + ", " + _toDisplayString(_ctx.money(p.TotalAmount || 0)) + " " + _toDisplayString(p.Currency) + " ", 1),
                          (p.PaymentPercent != null)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_55, " (" + _toDisplayString(_ctx.roundTo(p.PaymentPercent, 2)) + "%) ", 1))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_56, [
                _createElementVNode("div", _hoisted_57, [
                  _createElementVNode("div", _hoisted_58, _toDisplayString(_ctx.$t('comment')) + ":", 1),
                  (_ctx.isPayment && _ctx.isPaymentEditMode && !_ctx.canEditPaymentNote)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_59, [
                        _createVNode(_component_app_icon, {
                          name: "info-circle-outline",
                          width: "18px",
                          color: "#979797"
                        }),
                        _createVNode(_component_q_tooltip, {
                          delay: 300,
                          anchor: "top middle",
                          self: "center middle"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.paymentNoteEditHint), 1)
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true),
                  (!(_ctx.isPayment && _ctx.isPaymentEditMode && !_ctx.canEditPaymentNote))
                    ? (_openBlock(), _createBlock(_component_native_input, {
                        key: 1,
                        ref: "comment_field",
                        style: {"width":"-webkit-fill-available"},
                        class: "q-mx-sm",
                        "disabled-field": _ctx.isPayment ? !_ctx.canEditPaymentNote : true,
                        "show-border": _ctx.isPayment ? _ctx.isPaymentEditMode : false,
                        "edit-on-click": _ctx.canEditPaymentNote,
                        "model-value": _ctx.isPayment && _ctx.isPaymentEditMode ? _ctx.editPaymentForm.note : (_ctx.isPayment ? _ctx.payInfoContainer.Note : _ctx.billInfoContainer.Note),
                        "onUpdate:modelValue": _ctx.onPaymentNoteUpdate
                      }, null, 8, ["disabled-field", "show-border", "edit-on-click", "model-value", "onUpdate:modelValue"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_60, [
                _createElementVNode("div", _hoisted_61, _toDisplayString(_ctx.$t('linked')) + ": ", 1),
                _createElementVNode("div", _hoisted_62, [
                  (_ctx.tmp_connections.length)
                    ? (_openBlock(), _createBlock(_component_connections_table_html, {
                        key: 0,
                        ref: "connectionsTableRef",
                        modelValue: _ctx.tmp_connections,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.tmp_connections) = $event)),
                        onRemoveItem: _ctx.removeConnection,
                        onCheckError: _ctx.onCheckError,
                        "max-amount": _ctx.billInfoContainer.CalculatedAmount,
                        "max-payed": _ctx.billInfoContainer.PayedAmount,
                        "hide-remove-btn": _ctx.isPayment,
                        "show-non-existent": !_ctx.isPayment,
                        "check-sums": !_ctx.isPayment,
                        "show-sums": !_ctx.isPayment,
                        "read-only": _ctx.readOnly,
                        onRecalc: _ctx.writeConnections
                      }, null, 8, ["modelValue", "onRemoveItem", "onCheckError", "max-amount", "max-payed", "hide-remove-btn", "show-non-existent", "check-sums", "show-sums", "read-only", "onRecalc"]))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", _hoisted_63, _toDisplayString(_ctx.errorText), 1),
                  (_ctx.thisConnCached)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_64, _toDisplayString(_ctx.$t('new_bindings_until_save')), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_65, [
                _createElementVNode("div", _hoisted_66, [
                  _createElementVNode("div", _hoisted_67, _toDisplayString(_ctx.$t('one_c_instance')) + ":", 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.isPayment ? _ctx.payInfoContainer.Instance1C : _ctx.billInfoContainer.Instance1C), 1)
                ])
              ])
            ]))
      ]),
      (_ctx.isPayment && !_ctx.readOnly)
        ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
            _createElementVNode("div", _hoisted_69, [
              _createVNode(_component_q_btn, {
                "no-caps": "",
                unelevated: "",
                color: "primary",
                label: _ctx.isPaymentEditMode ? (_ctx.paymentSaveLoading ? _ctx.$t('loading') + '...' : _ctx.$t('save')) : _ctx.$t('edit'),
                disable: _ctx.paymentSaveLoading || (_ctx.isPaymentEditMode && !_ctx.canSavePaymentEdit),
                onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (_ctx.isPaymentEditMode ? _ctx.savePaymentEdit() : _ctx.startPaymentEdit()), ["stop"]))
              }, null, 8, ["label", "disable"]),
              (_ctx.isPaymentEditMode)
                ? (_openBlock(), _createBlock(_component_q_btn, {
                    key: 0,
                    label: _ctx.$t('cancel'),
                    "no-caps": "",
                    flat: "",
                    onClick: _withModifiers(_ctx.cancelPaymentEdit, ["stop"])
                  }, null, 8, ["label", "onClick"]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}